import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

const searchSchema = z.object({
  classificationTab: z
    .enum(["journals", "ledgers"])
    .catch("ledgers")
    .default("ledgers"),
  classificationTemplateId: z.string().optional(),
});

export const Route = createFileRoute(
  "/_protected/auditor/clients/$id/_client-tabs/input-process/classification",
)({
  validateSearch: searchSchema,
});
